module.exports = __webpack_public_path__ + "static/1312649315.04028aee.jpg";